import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Button, Modal, Badge, Spinner, EmptyState, PageHeader } from '../components/Common';
import { API_URL } from '../config';

const API = `${API_URL}/super-admin`;
const getToken = () => localStorage.getItem('bhamsa_sa_token');

const SuperAdminNotifications = () => {
  const [admins,     setAdmins]     = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [showModal,  setShowModal]  = useState(false);
  const [sending,    setSending]    = useState(false);
  const [form,       setForm]       = useState({
    user_id: '', message: '', type: 'general',
    send_whatsapp: true, send_email: false,
  });

  useEffect(() => {
    axios.get(`${API}/admins`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
    .then(r => setAdmins(r.data.admins))
    .catch(() => toast.error('Admins load nahi hue'))
    .finally(() => setLoading(false));
  }, []);

  const handleSend = async () => {
    if (!form.user_id || !form.message) {
      toast.error('Admin aur message required hai'); return;
    }
    setSending(true);
    try {
      const res = await axios.post(`${API}/send-notification`, form, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      toast.success('Notification bhej di gayi! ✅');
      if (res.data.whatsapp_sent) toast.success('📱 WhatsApp bheja gaya!');
      if (res.data.email_sent)    toast.success('📧 Email bheja gaya!');
      setShowModal(false);
      setForm({ user_id: '', message: '', type: 'general', send_whatsapp: true, send_email: false });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error');
    } finally { setSending(false); }
  };

  const quickMessages = [
    { label: '⚠️ Plan Expiry Reminder', text: 'Aapka plan jald expire hone wala hai. Please renew karein.' },
    { label: '❌ Plan Expired',          text: 'Aapka plan expire ho gaya hai. Nayi service ke liye contact karein.' },
    { label: '🎉 Plan Activated',        text: 'Aapka plan successfully activate ho gaya hai. Thank you!' },
    { label: '🔧 Maintenance',           text: 'Kal raat 12 baje system maintenance hogi. 1 ghante ke liye service band rahegi.' },
  ];

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  if (loading) return <Spinner />;

  return (
    <div className="page">
      <PageHeader
        title="🔔 Notifications"
        subtitle="Admins ko WhatsApp aur Email notifications bhejo"
        actions={
          <Button onClick={() => setShowModal(true)}>
            📢 Notification Bhejo
          </Button>
        }
      />

      {/* Admin List with Quick Send */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">👥 Sab Admins</span>
        </div>
        <div className="table-wrap">
          {admins.length === 0 ? (
            <EmptyState icon="👥" title="Koi admins nahi" />
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Shop</th><th>Name</th><th>WhatsApp</th>
                  <th>Email</th><th>Plan Status</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {admins.map(a => (
                  <tr key={a.id}>
                    <td><strong>{a.shop_name || '—'}</strong></td>
                    <td>{a.name}</td>
                    <td style={{ color: 'var(--accent2)' }}>
                      {a.whatsapp ? `📱 ${a.whatsapp}` : '—'}
                    </td>
                    <td style={{ fontSize: 12, color: 'var(--text2)' }}>
                      {a.email || '—'}
                    </td>
                    <td>
                      <Badge variant={
                        a.subscription_status === 'active'  ? 'green' :
                        a.subscription_status === 'trial'   ? 'orange' : 'red'
                      }>
                        {a.subscription_status}
                      </Badge>
                    </td>
                    <td>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          f('user_id', String(a.id));
                          setShowModal(true);
                        }}
                      >
                        📢 Send
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Send Modal */}
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="📢 Notification Bhejo"
        size="md"
      >
        <div className="form-group">
          <label className="form-label">Admin Select Karo *</label>
          <select
            className="form-input"
            value={form.user_id}
            onChange={e => f('user_id', e.target.value)}
          >
            <option value="">-- Admin choose karo --</option>
            {admins.map(a => (
              <option key={a.id} value={a.id}>
                {a.shop_name} — {a.name}
              </option>
            ))}
          </select>
        </div>

        {/* Quick Messages */}
        <div className="form-group">
          <label className="form-label">Quick Messages</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {quickMessages.map((qm, i) => (
              <button
                key={i}
                className="btn btn-secondary btn-sm"
                onClick={() => f('message', qm.text)}
              >
                {qm.label}
              </button>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Message *</label>
          <textarea
            className="form-input"
            rows={4}
            placeholder="Notification message likho..."
            value={form.message}
            onChange={e => f('message', e.target.value)}
            style={{ resize: 'vertical' }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Type</label>
          <select className="form-input" value={form.type} onChange={e => f('type', e.target.value)}>
            <option value="general">General</option>
            <option value="plan_expiry_reminder">Plan Expiry Reminder</option>
            <option value="plan_expired">Plan Expired</option>
            <option value="plan_purchase">Plan Purchase</option>
          </select>
        </div>

        <div style={{ display: 'flex', gap: 20, marginBottom: 16 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
            <input
              type="checkbox"
              checked={form.send_whatsapp}
              onChange={e => f('send_whatsapp', e.target.checked)}
            />
            📱 WhatsApp pe bhejo
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
            <input
              type="checkbox"
              checked={form.send_email}
              onChange={e => f('send_email', e.target.checked)}
            />
            ✉️ Email pe bhejo
          </label>
        </div>

        <div className="modal-footer">
          <Button variant="ghost" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button onClick={handleSend} loading={sending}>📢 Bhejo</Button>
        </div>
      </Modal>
    </div>
  );
};

export default SuperAdminNotifications;